import Notes from '@mui/icons-material/Notes'
import React from 'react'
import IconButton from './IconButton'

const NoteButton = (props: any) => (
  <IconButton {...props}>
    <Notes fontSize='inherit' />
  </IconButton>
)

export default NoteButton
